export const KPI_URL = '/api/v2/kpis';
export const KPI_CRUDURL = '/api/v2/kpi';
export const KPI_OPERATION_URL = '/api/v2/kpiOperations';
export const KPI_OPERATION_CRUDURL = '/api/v2/kpiOperation';

export const KPI_EXECUTIONS_URL = (id: string) => `/api/v2/kpi/${id}/executions`;
export const KPI_EXECUTE_URL = (id: string) => `/api/v2/kpi/${id}/execute`;

export const KPI_EXECUTION_RESULTS_URL = (id: string, executionId?: string) =>
  `/api/v2/kpi/${id}/execution/${executionId}/results`;
export const KPI_LIST_EXECUTIONS_URL = (id: string) => `/api/v2/kpi/${id}/executions`;
export const KPI_LATEST_EXECUTIONS_URL = (id: string) => `/api/v2/kpi/${id}/latestExecution/results`;

export const KPI_EXECUTIONS_STATISTICS_URL = (id: string, executionId?: string) =>
  `/api/v2/kpi/${id}/execution/${executionId}/statistics`;
export const KPI_LATEST_EXECUTION_STATISTICS_URL = (id: string) => `/api/v2/kpi/${id}/latestExecution/statistics`;

export const KPI_OPERATION_TYPES = [
  { id: 'time_between_events', icon: 'date_range' },
  { id: 'count_events', icon: 'format_list_numbered' },
  { id: 'interval_summation', icon: 'functions', icon2: 'date_range' },
  { id: 'inter_event_item_usage', icon: 'data_usage' },
  { id: 'geometries_presence', icon: 'share_location' },
  { id: 'value_between_readings', icon: 'ssid_chart' },
];
